import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementSidebar from "../components/tour/TourManagementSidebar";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { usePackage } from "../hooks/usePackage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { toast } from "react-toastify";
import {
  setPackageData,
  setPackageGallery,
  setOptionsData,
  resetOptionsData,
} from "../reducer/tourReducer";
import { setOptionEdit, setOptionEdit2 } from "../reducer/tourEditReducer";
import { CreatePackageProps } from "../declarations/tourServices";
import OptionsList from "../components/packages/OptionsList";
import CreateOptionsModal from "../components/packages/CreateOptionsModal";
import { useOptions } from "../hooks/useOptions";

const mockOptions = [
  {
    _id: "1",
    title: "Option 1",
    referenceCode: "OPT123",
    maxGroupSize: "10 people",
    isPrivate: false,
    cutOffTime: "48 hours before the event",
  },
  {
    _id: "2",
    title: "Option 2",
    referenceCode: "OPT124",
    maxGroupSize: "20 people",
    isPrivate: true,
    cutOffTime: "48 hours before the event",
  },
];

// todo: on options add a status part where it will show temporary and saved by checking is preoption true and edit option needs to start from the progress i have stopped on

// todo: package category being reset on creating option
function TourManagementPackageOptionsPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { createPackage } = usePackage();
  const { packageData, gallery } = useSelector(
    (state: RootState) => state.tour
  );
  const { getOptions, deleteOptions } = useOptions();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOptionId, setSelectedOptionId] = useState<string | null>(null);
  const open = Boolean(anchorEl);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOptionType, setSelectedOptionType] = useState("new");
  const [selectedExistingOption, setSelectedExistingOption] = useState("");
  const { optionsData, PrepackageDataId, optionsList } = useSelector(
    (state: RootState) => state.tour
  );
  // const [optionsListData, setOptionsListData] = useState<any[]>(
  //   Array.isArray(optionsList) && optionsList.length > 0
  //     ? optionsList
  //     : mockOptions
  // );

  console.log("packageData in options page", optionsData);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    optionId: string
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedOptionId(optionId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedOptionId(null);
  };

  const handleDeleteOption = async (optionid: string) => {
    console.log(`Delete option with id: ${optionid}`);
    try {
      await deleteOptions(optionid);
      toast.success("Option deleted successfully");
    } catch (error) {
      toast.error("Failed to delete option");
    }
    handleMenuClose();
  };

  const handleEditOption = (optionId: string) => {
    console.log(`Edit option with id: ${optionId}`);
    const option = optionsList.find((option) => option._id === optionId);
    dispatch(setOptionsData(option));
    dispatch(setOptionEdit2({ optionId }));
    navigate(Paths.tourManagementPackageOptionsSetup);
  };

  useOnLoadPage({ tabActive: "create" });

  const handleCreateOption = () => {
    handleModalOpen();
  };

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedOptionType("new");
    setSelectedExistingOption("");
  };

  console.log("package id in options page", PrepackageDataId);
  console.log("options data in options page", optionsData);

  const handleModalContinue = () => {
    if (selectedOptionType === "new") {
      dispatch(resetOptionsData());
      dispatch(
        setOptionsData({
          package: PrepackageDataId,
        })
      );
      navigate(Paths.tourManagementPackageOptionsSetup);
    } else {
      console.log(
        `Using existing option as template: ${selectedExistingOption}`
      );
      const selectedOption = optionsList.find(
        (option) => option._id === selectedExistingOption
      );
      console.log("Selected option before cloning:", selectedOption);
      if (selectedOption) {
        // Deep clone and remove _id
        const templateOption = JSON.parse(JSON.stringify(selectedOption));
        delete templateOption._id;
        console.log(
          "Template option after cloning and removing _id:",
          templateOption
        );
        dispatch(setOptionsData(templateOption));
      } else {
        console.log("No option found for template!");
      }
      navigate(Paths.tourManagementPackageOptionsSetup);
    }
    handleModalClose();
  };

  console.log("mealSettings before parsing:", packageData.mealSettings);

  const onContinue = async () => {
    if (!optionsList || optionsList.length === 0) {
      toast.error(
        "You need to create at least one option to create a package."
      );
      return;
    }

    setLoading(true);

    // Fix: Parse mealSettings if it's an array of JSON strings
    let parsedMealSettings: any[] = [];
    if (Array.isArray(packageData.mealSettings)) {
      parsedMealSettings = packageData.mealSettings.map((item: any) => {
        if (typeof item === "string") {
          try {
            return JSON.parse(item);
          } catch {
            return item;
          }
        }
        return item;
      });
    }

    const updatedPackageData = {
      ...packageData,
      optionIds: Array.isArray(optionsList)
        ? optionsList.map((option) => option._id)
        : [],
      mealSettings: parsedMealSettings,
      startingDate: new Date().toISOString(),
    };

    try {
      const response = await createPackage({ payload: updatedPackageData });
      console.log("API Response for create package:", response);
      if (response?.status === 201) {
        navigate(Paths.welcome);
      }
    } catch (error) {
      console.error("Error creating package:", error);
      toast.error("An error occurred while creating the package.");
    } finally {
      setLoading(false);
    }
  };

  const fetchOptions = async () => {
    setLoading(true);

    try {
      const response = await getOptions({ id: PrepackageDataId });
      console.log("API options in options page Response:", response);
    } catch (error) {
      console.error("Error fetching options:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  console.log("packageData in options page", packageData);

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementSidebar selected={12} />

        <div className={Classname.detail}>
          <div className={Classname.title}>Add option(s) to your product</div>
          <div className={Classname.description}>
            Options allow you to customize your activity and attract more
            customers. For example, your options can have different:
          </div>
          <div className="mb-6 ml-4">
            <li>durations (1 or 2 hours)</li>
            <li>
              group sizes (10 or 20 people) or set-ups (private or public)
            </li>
            <li>inclusions (with or without lunch)</li>
            <li>ways to start the activity (meeting point or hotel pickup)</li>
          </div>
          <div className={Classname.description}>
            The option is where the pricing/availability are stored, and where
            bookings are made. So you need at least one option per product to
            start receiving bookings.
          </div>
          {/* Show loading indicator while fetching options */}
          <div className="w-full max-w-2xl">
            {loading ? (
              <div className="text-center text-gray-500">
                Loading options...
              </div>
            ) : optionsList.length > 0 ? (
              <OptionsList
                options={optionsList}
                onEditOption={handleEditOption}
                onDeleteOption={handleDeleteOption}
              />
            ) : (
              <div className="text-gray-500 font-semibold mb-6">
                No options available. Please create a new option to get started.
              </div>
            )}
          </div>
          <button
            className={Classname.optionButton}
            onClick={handleCreateOption}
          >
            Create new option
          </button>
          {/* Modal */}
          <CreateOptionsModal
            open={modalOpen}
            onClose={handleModalClose}
            selectedOptionType={selectedOptionType}
            setSelectedOptionType={setSelectedOptionType}
            selectedExistingOption={selectedExistingOption}
            setSelectedExistingOption={setSelectedExistingOption}
            onContinue={handleModalContinue}
            options={optionsList}
          />
          <div className={Classname.buttonsContainer}>
            <button className={Classname.continueButton} onClick={onContinue}>
              {loading ? "Please Wait..." : "Create Package"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageOptionsPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full text-gray-600",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4 mt-2",
  buttonsContainer: "flex flex-1 justify-end gap-3 mt-10",
  optionButton:
    "font-bold w-fit flex items-center gap-2 cursor-pointer text-primary1 py-3 px-3 border-primary1 border rounded-lg",
  saveButton:
    "h-12 px-6 flex items-center justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
